var map = {
	"./ai.png": 494,
	"./computer_literacy.png": 495,
	"./ege-informatika-desk.png": 421,
	"./ege-informatika.png": 422,
	"./frontend.png": 496,
	"./game_design.png": 497,
	"./graphic_design.png": 498,
	"./math-desk.png": 423,
	"./math.png": 424,
	"./predprinimatelstvo.png": 499,
	"./programming_basics.png": 500,
	"./python.png": 501,
	"./scratch.png": 502,
	"./unity.png": 503,
	"./videoblogging.png": 504,
	"./web-razrabotka.png": 505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 848;